const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  create ({ state, commit, rootState }, params) {
    return rootState.axios.post('/magicbuy/v1frontend/dgorder-rating/create', params, {
    })
  },
  view ({ state, commit, rootState }, params) {
    return rootState.axios.get('/magicbuy/v1frontend/dgorder-rating/view', { params }, {
    })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
